import { Component, OnInit, AfterViewInit } from "@angular/core";
import { SchoolService } from "../../../shared/services/school.service";
import { DistrictAdministrationService } from "../services/districtadministration.service";
import { LocalstorageService } from "../../../shared/services/localstorage.service";
import { HttpclientService } from "../../../shared/services/httpclient.service";
import { UserService } from "../../../shared/services/user.service";
import { ConfirmationService, LazyLoadEvent } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import { DistrictUpdateRequest } from "./DistrictUpdateRequest";

@Component({
	selector: "caass-districtadmin",
	templateUrl: "./districtcontactinfo.component.html",
})
export class DistrictContactInfoComponent {
	constructor(
		private schoolService: SchoolService,
		private router: Router,
		private localStorage: LocalstorageService,
		private districtadministrationService: DistrictAdministrationService,
		private confirmationService: ConfirmationService
	) {}
	// district={
	//   DistrictID:0,
	//   DistrictName:'',
	//   Phone:'',
	//   Street:'',
	//   City:'',
	//   State:'',
	//   Zip:'',

	// }
	Contact: any = {};
	SaveErrorMessage = "";
	ngOnInit() {
		this.DistrictList();
	}
	private DistrictList() {
		var result = this.districtadministrationService.DistrictList();
		result.subscribe(
			(response: any) => {
				this.Contact = response;
			},
			(error) => {}
		);
	}
	SaveDone = "";
	// SaveErrorMessage = '';
	UpdateDistrict() {
		this.SaveErrorMessage = "";
		this.SaveDone = "";

		let parms: DistrictUpdateRequest = {
			DistrictID: this.Contact.DistrictID,
			DistrictName: this.Contact.DistrictName,
			DistrictDisplayName: this.Contact.DistrictDisplayName,
			Phone: this.Contact.Phone,
			Street: this.Contact.Street,
			City: this.Contact.City,
			State: this.Contact.State,
			Zip: this.Contact.Zip,
		};

		var result = this.districtadministrationService.DistrictUpdate(parms);

		result.subscribe(
			// (response: any) => {

			//     var res: any = response

			//     if (response) {
			//         this.SaveErrorMessage = response
			//     } else {
			//         this.router.navigate(['/siteadmin/district']);
			//     }
			//     this.SaveDone="Data Successfully Updated";

			// }
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "District Contact Info was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the District's Contact Info",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			}
		);
	}
}
